export default "__VITE_ASSET__BjuREPJD__"